const IconMessageChat = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <g data-name="Caminho 12255" style={{ fill: "none" }}>
        <path
          d="M2.01 4A2 2 0 0 1 4 2h16a2.006 2.006 0 0 1 2 2v12a2.006 2.006 0 0 1-2 2H6l-4 4z"
          style={{ stroke: "none" }}
          transform="translate(-2 -2)"
        />
        <path
          d="M4.01 4v.001L4.003 17.17 5.172 16h14.824a.03.03 0 0 0 .004-.004V4.004A.03.03 0 0 0 19.996 4H4.011M4 2h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H6l-4 4 .01-18c0-1.1.89-2 1.99-2z"
          style={{ fill: "#580c81", stroke: "none" }}
          transform="translate(-2 -2)"
        />
      </g>
    </svg>
  );
};

export default IconMessageChat;
